<template>
  <!-- 穿梭框组件 getSubordinateList-->
  <div>
    <div class="transfernew">
      <div class="left">
        <h3>选择 <span></span></h3>
        <Input placeholder="搜索" class="left-input" v-model="searvhValue" @on-enter="tosearch" @on-clear="clearsearch" clearable>
        <Icon type="ios-search" slot="prefix" @click="clearsearch" />
        </Input>
        <ul>
          <li v-show="item" v-for="(item,index) in dataleftlist" :key="index">
            <span class="span-left">
              <Checkbox class="icon-i" @on-change="changeCheck(item,index)" v-model="item.isactive"> <span class="icon-i"></span>{{item.roleName}} </Checkbox>
            </span>
          </li>
        </ul>
      </div>
      <div class="left right">
        <h3>已选 <span style="float:right;margin-right:15px;">{{selectedNum}}</span></h3>
        <Input placeholder="搜索" class="left-input" v-model="searvhValue2" @on-enter="tosearchs" @on-clear="clearsearchs" clearable>
        <Icon type="ios-search" slot="prefix" @click="tosearchs" />
        </Input>
        <ul>
          <li v-show="item" v-for="(item,index) in datarightlist" :key="index" @click="deletitem(item,index)">
            {{item.roleName}}
            <span class="item-span2">
              <Icon type="ios-close-circle-outline" /></span>
          </li>
        </ul>
      </div>

    </div>
    <div class="secondBumen-bottom">
      <Button class="btn" type="success" ghost @click="postTarget(1)">取消</Button>
      <Button class="btn sure" :class="{'btns' : this.sessionParentList.length!==0}" type="success" ghost @click="postTarget(2)">确定</Button>
    </div>
  </div>
</template>
<script>
import { getSubordinateList, selectRole, getRoleListByUserId } from '../servers/api'
import { log } from 'util';
export default {
  name: 'transfer',
  props: {
    titleObj: Object
  },
  data () {
    return {
      selectedNum: 0,//已选择的数量
      fruit: ['系统管理员'],
      titleListlength: 3,
      titles: ['选择', '已选'],//标题集合
      datalist: [],
      searvhValue2: '',//搜索值
      cityItem: '',
      data: [],
      dataleftlist: [],//左侧展示数组
      datarightlist: [],//右侧数组展示
      searvhValue: '',//搜索值
      sessionParentList: [],
      userId: ''
    }
  },
  created () {

  },
  methods: {
    changeCheck (item) {//勾选或取消勾选 左侧插入右侧
      if (item.isactive == true) {
        this.datarightlist.push(item)
        this.selectedNum = this.datarightlist.length;
      } else {
        for (let i = 0; i < this.datarightlist.length; i++) {
          if (item.roleId == this.datarightlist[i].roleId) {
            this.datarightlist.splice(i, 1)
          }
        }
        this.selectedNum = this.datarightlist.length;
      }
    },
    selectRole () {//左侧所有的接口
      selectRole().then(res => {
        if (res.data.code == 1) {
          this.dataleftlist = res.data.data || [];
          this.change()
        }
      })
    },
    change () {//右侧跟左侧对比 左侧含有右侧的就勾选上
      for (let i = 0; i < this.dataleftlist.length; i++) {
        this.dataleftlist[i].isactive = false
        for (let j = 0; j < this.datarightlist.length; j++) {
          if (this.datarightlist[j].roleId === this.dataleftlist[i].roleId) {
            this.dataleftlist[i].isactive = true;
          }
        }
      }
      this.selectedNum = this.datarightlist.length;
    },
    getRoleListByUserId (item, id) {//右侧已选的接口;
      if (id) {
        this.userId = id;
      }
      let params = {
        userId: this.userId
      }
      this.selectRole()
      getRoleListByUserId(params).then(res => {
        if (res.data.code == 1) {
          this.datarightlist = res.data.data.roleList || [];
          this.selectedNum = this.datarightlist.length;
          this.change()
        }
      })
    },
    deletitem (item, index) {//删除右侧
      this.datarightlist.splice(this.datarightlist.indexOf(item), 1)
      this.selectedNum = this.datarightlist.length;
      this.change()
    },
    clearsearch () {//清除左面的input搜索框内容
      this.selectRole()
    },
    clearsearchs () {//清除you面的input搜索框内容
      this.getRoleListByUserId()
    },
    tosearchs () { //搜索2
      if (this.searvhValue2 !== '') {
        let list = [];
        for (let i = 0; i < this.datarightlist.length; i++) {
          if (this.datarightlist[i].roleName.indexOf(this.searvhValue2) > -1) {
            list.push(this.datarightlist[i])
          }
        }
        this.datarightlist = list;
        this.selectedNum = this.datarightlist.length;
      } else {
        this.clearsearchs()
      }
    },
    tosearch () { //搜索
      if (this.searvhValue !== '') {
        let list = [];
        for (let i = 0; i < this.dataleftlist.length; i++) {
          if (this.dataleftlist[i].roleName.indexOf(this.searvhValue) > -1) {
            list.push(this.dataleftlist[i])
          }
        }
        this.dataleftlist = list;
      } else {
        this.clearsearch()
      }
    },
    postTarget (index) {//提交穿梭框
      if (index == 1) {
        this.$emit('postRightList', false)
      } else {
        let list = [];
        let loginNameList = [];
        if (this.datarightlist.length > 0) {
          for (let i = 0; i < this.datarightlist.length; i++) {
            list.push(this.datarightlist[i].roleId)
            loginNameList.push(this.datarightlist[i].roleName)
          }

          this.$emit('postRightList', list, loginNameList)
        } else {
          this.$emit('postRightList', "空")
        }

      }

    },
  }
}
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";

.ivu-breadcrumb > span {
  color: #53cac3;
  cursor: pointer;
}
.btns {
  color: #fff;
  background: #53cac3;
}

.ivu-breadcrumb /deep/ .ivu-breadcrumb-item-separator {
  margin: 0 2px;
}
.secondBumen-bottom {
  font-family: SimHei;
  width: 100%;
  margin-top: 15px;
  text-align: center;
  .btn {
    margin-right: 15px;
  }
}
.ivu-breadcrumb .hahaha {
  display: none;
}
.ivu-breadcrumb > span:last-child {
  color: #7f7f7f;
}
.transfernew {
  // cursor: pointer;
  font-family: SimHei;
  font-size: 13px;
  width: 700px;
  height: 450px;
  .right {
    margin-left: 15px;
  }
  .left {
    width: 327px;
    height: 450px;
    border: 1px solid #53cac3;
    border-radius: 5px;
    float: left;
    h3 {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
      border-bottom: 1px solid #53cac3;
    }
    .left-input {
      width: 255px;
      margin-left: 15px;
      margin-top: 15px;
    }
    .p {
      padding-left: 15px;
      margin-top: 5px;
      height: 35px;
      width: 100%;
      span i {
        color: #53cac3;
      }
    }
    ul {
      display: block;
      height: 340px;
      overflow: hidden;
      overflow-y: scroll;
      width: 95%;
      padding-left: 15px;
      line-height: 30px;
      li {
        display: inline-block;
        width: 100%;
        padding-left: 15px;
        line-height: 20px;
        cursor: pointer;
      }
      .icon-i {
        margin-right: 5px;
      }
      .icon-i-active {
        color: #53cac3;
      }
      .span-left {
        width: 200px;
        display: inline-block;
      }
      .item-span {
        display: inline-block;
        width: 80px;
        float: right;
        height: 100%;
        border-left: 1px solid #d7d7d7;
        padding-left: 15px;
      }
      .item-span-active {
        color: #53cac3;
      }
      .item-span2 {
        width: 20px;
        height: 100%;
        float: right;
        margin-right: 15px;
      }
    }
    ul::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/tan/transfernew.vue